import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { detectDevice } from 'Utils';

export const getRum = () => {
  try {
    if (process.env.REACT_APP_NODE_ENV === 'local' || process.env.REACT_APP_NODE_ENV === 'stg') {
      throw new Error('Do not load RUM in local env');
    }
    const cognitoGuestRoleArn = process.env.REACT_APP_COGNITO_GUEST_ROLE_ARN;
    const awsRumIdentityPoolId = process.env.REACT_APP_RUM_IDENTITY_POOL_ID;
    const _awsRumSessionSampleRate = process.env.REACT_APP_RUM_SESSION_SAMPLE_RATE;
    const awsRumApplicationId = process.env.REACT_APP_RUM_APPLICATION_ID;
    let applicationVersion = process.env.REACT_APP_APPLICATION_VERSION;
    const buildNumber = process.env.REACT_APP_BUILD_NUMBER;
    const commitHash = process.env.REACT_APP_LAST_COMMIT;
    const branchName = process.env.REACT_APP_BRANCH;

    if (!awsRumApplicationId) {
      throw new Error('AWS RUM application ID not set');
    }
    if (!applicationVersion) {
      console.warn('AWS RUM application version not set');
      applicationVersion = '1.0.0';
    }
    // Use 100% sample rate to ensure all errors are captured
    // AWS RUM does not support exempting errors from session sampling
    const sessionSampleRate = 1;

    // releaseId is used to match source maps for stack trace de-minification
    // Format: version-build-commit (e.g., 1.1.8-73-a1b2c3d)
    // This must match the S3 path where source maps are uploaded
    const releaseId =
      process.env.REACT_APP_RELEASE_ID ||
      (buildNumber && commitHash
        ? `${applicationVersion}-${buildNumber}-${commitHash}`
        : applicationVersion);

    const config: AwsRumConfig = {
      allowCookies: true,
      releaseId: releaseId,
      guestRoleArn: cognitoGuestRoleArn,
      identityPoolId: awsRumIdentityPoolId,
      sessionSampleRate: sessionSampleRate,
      sessionEventLimit: 0, // 0 = unlimited (for testing, can reduce later)
      // Add build metadata as session attributes so they're searchable in RUM
      sessionAttributes: {
        appVersion: applicationVersion,
        buildNumber: buildNumber || 'unknown',
        commitHash: commitHash || 'unknown',
        branch: branchName || 'unknown',
        device: detectDevice(),
      },
      telemetries: [
        'errors',
        ['performance', { recordAllTypes: ['document', 'script', 'other'] }],
        [
          'http',
          {
            recordAllRequests: true,
            urlsToExclude: [
              new RegExp('/audio-samples/.+'),
              new RegExp('https://dataplane.rum.us-west-2.amazonaws.com/.+'),
            ],
          },
        ],
      ],
      eventPluginsToLoad: [],
    };

    return new AwsRum(
      awsRumApplicationId as string, // we want this to fail if it isn't set
      applicationVersion,
      'us-west-2',
      config,
    );
  } catch (_error) {
    return undefined;
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
};

function recordRumError(rum: AwsRum, userId: string, analyticsId: string, error: Error) {
  rum?.addSessionAttributes({
    museflowUserId: userId,
    analyticsSessionId: analyticsId,
  });
  rum?.recordError(error);
}

const awsRum = getRum();

export { awsRum, recordRumError };
